export default __webpack_public_path__ + "static/ShipEmblem-c874eb93dfca3e8bfb84774d9ccff8ce.jpg";